import useResource from 'app/hooks/useResource';

import {
  customers as resource
} from 'app/resources';

import {
  getCustomers,
  setCustomerParams
} from 'app/actions/customers';

import {
  createCustomer,
  updateCustomer,
  destroyCustomers
} from 'app/services/customers';

const useCustomers = (props = {}) => {
  const {
    onCreate
  } = props;

  return useResource({
    resource,
    getResource: getCustomers,
    createResource: createCustomer,
    updateResource: updateCustomer,
    destroyResource: destroyCustomers,
    setResourceParams: setCustomerParams,
    onCreate
  });
}

export default useCustomers;
